module.exports = __webpack_public_path__ + "static/media/OrthoInative.3fc7c171.png";